import { useEffect, useState, useSyncExternalStore } from "react";
import { MapClient, type ClientState } from "./map-client.js";

/**
 * Connects to a map's live room for as long as the component is mounted. The client is created
 * once (render does no I/O) and started in an effect, so React Strict Mode's mount, unmount,
 * mount just starts it again. Render the component with `key={mapId}` to switch maps.
 */
export function useMapClient(mapId: string): { client: MapClient; state: ClientState } {
  const [client] = useState(() => new MapClient(mapId));
  useEffect(() => {
    client.start();
    return () => client.close();
  }, [client]);
  const state = useSyncExternalStore(client.subscribe, client.getState);
  return { client, state };
}
